import restApi from "./api/rest"
import graphqlApi from "./api/graphql"
export type * from "./api/graphql"
export type * from "./api/rest"

const api = {
  ...restApi,
  ...graphqlApi,
}

export default api
